import React from "react";
import {SearchForm} from "./searchForm"
import EntityList from "./entityList"
const Entity = ():JSX.Element => {
    return (
        <>
            <SearchForm/>
            <EntityList/>               
        </>
    )
}
export default Entity